export default __webpack_public_path__ + "static/student_research_project-4f1098df45347a7d6043dcf5cb4fc381.png";